import { render, staticRenderFns } from "./paymentInfo.vue?vue&type=template&id=6bad94c9&scoped=true&"
import script from "./paymentInfo.vue?vue&type=script&lang=js&"
export * from "./paymentInfo.vue?vue&type=script&lang=js&"
import style0 from "./paymentInfo.vue?vue&type=style&index=0&id=6bad94c9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bad94c9",
  null
  
)

export default component.exports